export enum RockyAnalyticsEvent {
  CheckIn = 'check-in',
  CsatPageVisit = 'csat-page-visit',
  CsatSurveySubmit = 'csat-survey-submit',
  OrgChartPageVisit = 'org-chart-page-visit',
}
